import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FEATURE_TOGGLE_TSPAY } from "../config";
import { loadAccounts, loadConfig } from "../store/actions/tspay";
import { getTsPayConfigStatus } from "../store/actions/tspay/onboarding";
import { clearSearched } from "../store/actions/company";
import useGetCompanies from "./useGetCompanies";

const useChangeCompany = () => {
  const auth = useSelector((state) => state.auth);
  const company = useSelector((state) => state.company);
  const main = useSelector((state) => state.main);

  const dispatchAction = useDispatch();

  const { setCommercialistiClientList } = useGetCompanies();

  const clearDefaultCompany = useCallback(() => {
    localStorage.removeItem("selectedClient");
    localStorage.removeItem("selectedClientID");
    if (main.myType !== "STUDIO") {
      localStorage.removeItem("selectedAccountantID");
      localStorage.removeItem("actualAccountantName");
    }
    if (!main.isIntegrated) {
      dispatchAction({
        type: "changeCompany",
        clientIdSelected: "",
        companySelected: "",
        companiesRequestText: "",
        companiesRequestPage: company.preSearchedCompany
          ? Math.round(company.preSearchedCompany.length / main.companiesRequestSize, 10)
          : main.companiesRequestPage // ricalcolo la page
      });
    }

    dispatchAction(clearSearched());
  }, []);

  const changeCompanySelected = (
    value, companyEl, companies
  ) => {
    if (!value || value === main.clientIdSelected) return;

    if (typeof value === "string") {
      let accountantUuid;
      let accountantID;
      let accountantCF;

      let selectedCompany = company.companies.find((el) => {
        return el.id === value;
      });
      /**
       * Se non lo trovo tra le companies allora può essere frutto di sola ricerca
       *
       */
      if (!selectedCompany) {
        selectedCompany =
          company && company.searchedCompany
            ? company.searchedCompany.find((el) => {
              return el.id === value;
            })
            : null;
      }

      if (!selectedCompany) {
        selectedCompany =
          companies?.find((el) => {
            return el.id === value;
          });
      }

      if (!selectedCompany) return;

      if (main.myType !== "STUDIO" && !selectedCompany.commercialistiList) {
        setCommercialistiClientList(selectedCompany.id);
      }
      if (selectedCompany.commercialistiList) {
        accountantUuid = selectedCompany.commercialistiList[0].uuid;
        accountantID = selectedCompany.commercialistiList[0].id;
        accountantCF = selectedCompany.commercialistiList[0].codiceFiscale;
      }

      localStorage.setItem("selectedClient", selectedCompany.codiceFiscale);
      localStorage.setItem("selectedClientID", selectedCompany.id);
      if (main.myType !== "STUDIO" && accountantID) {
        localStorage.setItem("studioSelected", accountantCF);
        localStorage.setItem("selectedAccountantID", accountantID);
        localStorage.setItem("selectedAccountantUUID", accountantID);
        localStorage.setItem("actualAccountantName", selectedCompany.commercialistiList[0].ragioneSociale);
      }
      if (!window.Cypress) {
        if (main.myType !== "STUDIO" && FEATURE_TOGGLE_TSPAY === "true") {
          dispatchAction(loadConfig(
            auth, accountantUuid, selectedCompany.uuid
          )).then((res) => {
            dispatchAction(loadAccounts(
              auth, accountantUuid, selectedCompany.uuid
            ));
          });
          if (!window.Cypress) {
            dispatchAction(getTsPayConfigStatus(auth, selectedCompany.uuid)).then((res) => {
              dispatchAction(loadAccounts(
                auth, accountantUuid, selectedCompany.uuid
              ));
            });
          }
        }
      }

      dispatchAction({
        type: "changeCompany",
        accountantUuidSelected: accountantUuid,
        accountantIdSelected: accountantID,
        accountantSelected: accountantCF,
        clientIdSelected: selectedCompany.id,
        companySelected: selectedCompany.codiceFiscale,
        companyUuidSelected: selectedCompany.uuid,
        append: !company.companies.find((el) => {
          return el.id === value;
        }),
        companyEl: companyEl,
        myType: main.myType === "STUDIO" ? main.myType : selectedCompany.classifier
      });
      if (!company.companies.find((el) => {
        return el.id === value;
      })){
        dispatchAction({
          type: "appendCompany",
          payload: companyEl
        });
      }
    } else {
      clearDefaultCompany();
    }
  };

  return { changeCompanySelected, clearDefaultCompany };
};

export default useChangeCompany;
